// src/reducers/notesReducer.ts (New Reducer)
import { CueNote } from '../state/notes-store';

export type NotesAction =
  | { type: 'SET_NOTES'; payload: CueNote[] }
  | { type: 'ADD_NOTE' }
  | { type: 'REMOVE_NOTE'; payload: { id: string } }
  | { type: 'UPDATE_TITLE'; payload: { id: string; title: string } }
  | { type: 'UPDATE_BODY'; payload: { id: string; body: string } }
  | { type: 'ADD_TRIGGER'; payload: { id: string; trigger: string } }
  | { type: 'UPDATE_TRIGGER'; payload: { id: string; index: number; trigger: string } }
  | { type: 'REMOVE_TRIGGER'; payload: { id: string; index: number } };

export function notesReducer(state: CueNote[], action: NotesAction): CueNote[] {
  switch (action.type) {
    case 'SET_NOTES':
      return action.payload;

    case 'ADD_NOTE':
      const newNote: CueNote = {
        id: `custom-${Date.now()}`,
        title: '',
        body_markdown: '',
        triggers: [],
      };
      return [...state, newNote];

    case 'REMOVE_NOTE':
      return state.filter(note => note.id !== action.payload.id);

    case 'UPDATE_TITLE':
      return state.map(note =>
        note.id === action.payload.id ? { ...note, title: action.payload.title } : note
      );
      
    case 'UPDATE_BODY':
      return state.map(note =>
        note.id === action.payload.id ? { ...note, body_markdown: action.payload.body } : note
      );

    case 'ADD_TRIGGER': {
      if (!action.payload.trigger.trim()) return state;
      return state.map(note => {
        if (note.id === action.payload.id) {
          return { ...note, triggers: [...note.triggers, action.payload.trigger.trim()] };
        }
        return note;
      });
    }
    
    case 'UPDATE_TRIGGER': {
      if (!action.payload.trigger.trim()) {
        // If update makes it empty, treat as a removal
        return notesReducer(state, { type: 'REMOVE_TRIGGER', payload: { id: action.payload.id, index: action.payload.index }});
      }
      return state.map(note => {
        if (note.id === action.payload.id) {
          const newTriggers = [...note.triggers];
          newTriggers[action.payload.index] = action.payload.trigger.trim();
          return { ...note, triggers: newTriggers };
        }
        return note;
      });
    }

    case 'REMOVE_TRIGGER':
      return state.map(note => {
        if (note.id === action.payload.id) {
          const newTriggers = [...note.triggers];
          newTriggers.splice(action.payload.index, 1);
          return { ...note, triggers: newTriggers };
        }
        return note;
      });
      
    default:
      return state;
  }
}